real.pad = function(number, length) {
    if(!length) {
        length = 2;
    }
    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
};